import { extend } from 'sk-ui/lib/utils/util.js'

import industryForm from './metaData/industryForm'

import sceneDir from '@/store/modules/sceneDirMng/metaData/sceneDir'
import scene from '@/store/modules/sceneMng/metaData/scene'

export default {
  IndustryCreate({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: industryForm,
      props
    })
  },
  IndustryEdit({ commit }, params) {
    const props = {
      title: '编辑行业',
      params: {
        id: params.rowIds[0]
      }
    }
    const editForm = extend(true, {}, industryForm)
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  },
  SceneManager({ commit }, params) {
    const props = {
      params: {
        industryId: params.row.id
      }
    }
    this.dispatch('OpenFullDialog', { metaData: scene, props })
  },
  SceneDirManager({ commit }, params) {
    const props = {
      params: {
        industryId: params.row.id
      }
    }
    this.dispatch('OpenFullDialog', { metaData: sceneDir, props })
  }
}
